/**
 * Client route paths for the multi-app shell. REST API paths (/api/...) are unchanged.
 */
export const ROUTES = {
  HOME: '/',
  HOME_ADMIN: '/home-admin',
  HELP: '/help',
  LOGIN: '/login',
  CHANGE_PASSWORD: '/change-password',
  SERVICE_REQUESTS: '/service-requests',
  SERVICE_REQUESTS_NEW: '/service-requests/new',
  ADMIN: '/admin',
  RAISE_THE_SAIL: '/raise-the-sail',
  RAISE_THE_SAIL_REPORTS: '/raise-the-sail/reports',
  RAISE_THE_SAIL_ADMIN: '/raise-the-sail/admin',
  RISK: '/risk',
  RISK_REPORTS: '/risk/reports',
  RISK_ADMIN: '/risk/admin',
  HOMESITE: '/homesite-inspections',
  HOMESITE_REPORTS: '/homesite-inspections/reports',
  HOMESITE_ADMIN: '/homesite-inspections/admin',
  RULES_VIOLATION: '/rules-violation',
  RULES_VIOLATION_REPORTS: '/rules-violation/reports',
  RULES_VIOLATION_ADMIN: '/rules-violation/admin',
  HURRICANE: '/hurricane',
  HURRICANE_REPORTS: '/hurricane/reports',
  HURRICANE_ADMIN: '/hurricane/admin',
  INVENTORY: '/inventory',
  INVENTORY_ADMIN: '/inventory/admin',
};

export function hurricaneReport(id) {
  return `/hurricane/report/${id}`;
}

export function hurricaneReportView(id) {
  return `/hurricane/reports/view/${id}`;
}

export function rulesViolationReport(id) {
  return `/rules-violation/violation/${id}`;
}

export function rulesViolationReportItem(itemId) {
  return `/rules-violation/reports/item/${itemId}`;
}

export function checklistInspect(id) {
  return `/raise-the-sail/inspect/${id}`;
}

export function riskInspect(id) {
  return `/risk/inspect/${id}`;
}

export function homesiteInspect(id) {
  return `/homesite-inspections/inspect/${id}`;
}

export function serviceRequestDetail(id) {
  return `/service-requests/${id}`;
}

export function serviceRequestEdit(id) {
  return `/service-requests/${id}/edit`;
}

/** Allow in-app return paths from query params (blocks open redirects). */
export function safeReturnPath(path) {
  if (!path || typeof path !== 'string') return null;
  const decoded = decodeURIComponent(path).trim();
  if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('://')) {
    return null;
  }
  return decoded;
}
